module.exports = __webpack_public_path__ + "static/img/cq-vfy.56de6e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/cq-vfy.jpg
// module id = hm8m
// module chunks = 1